<template>
  <v-container class="col-12">
    <v-card class="pa-4">
      <v-row class="mx-0">
        <select-project
          v-model="project"
          class="col-1"
          style="min-width: 250px; max-width: 250px"
        ></select-project>
        <v-btn color="info" v-on:click="search" class="mt-3" :disabled="loading" :loading="loading">Search</v-btn>
      </v-row>
    </v-card>


    <v-card class="pa-0 mt-4">
      <v-data-table
        :loading="loading"
        :server-items-length="total"
        :headers="headers"
        :options.sync="options"
        :items="items"
        :expanded.sync="expanded"
        sort-by="created"
        sort-desc
        item-key="account_transaction_id"
        :footer-props="{'items-per-page-options': [15, 25, 50, 100]}"
        :items-per-page="15"
        :class="{'payment-handler-dt': true, 'footer-padding': $store.state.auth.checkAccess({key: 'kiosk.access', value: true})}"
        show-expand
        style="z-index: 0; position: relative;"
      >
        <template v-slot:body.prepend>
          <tr class="grey lighten-3">
            <td
              v-for="header in headers"
              :key="header.text"
            >
              <v-select
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'select'"
                hide-details
                dense
                small
                multiple
                clearable
                persistent-hint
                return-object
                single-line
                class="data-table-finance-filter-select"
                :items="columnValueList(header.value)"
                v-model="filters[header.value].data"
              />
              <v-text-field
                class="data-table-finance-filter-textfield"
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'text'"
                v-model="filters[header.value].data"
                hide-details
              />
            </td>
          </tr>
        </template>

        <template v-slot:expanded-item="{ headers , item }">
          <td :colspan="headers.length">
            <v-row class="col-12 px-5 pb-0 payment-handler-details">

              <v-text-field
                :value="item.account_transaction_id"
                label="ID"
                small
                outlined
                readonly
                hide-details
                class="col-2"
              ></v-text-field>
              <v-text-field
                :value="item.login"
                label="Login"
                small
                outlined
                readonly
                hide-details
                class="col-2"
              ></v-text-field>
              <v-text-field
                :value="item.type"
                label="Type"
                small
                outlined
                readonly
                hide-details
                class="col-2"
              ></v-text-field>
              <v-select
                label="Status"
                :items="statuses"
                v-model="item.status"
                :readonly="!$store.state.auth.checkAccess({key: 'payment_handler_update', value: true})"
                hide-details
                small
                outlined
                class="col-2"
              ></v-select>
              <v-text-field
                v-model="item.amount"
                :label="`Amount (${item.currency})`"
                :suffix="item.currency"
                small
                outlined
                hide-details
                class="col-2  text-right"
              ></v-text-field>
              <v-text-field
                v-model="item.account"
                label="Reference"
                small
                outlined
                hide-details
                class="col-2"
              ></v-text-field>
              <v-text-field
                :value="item.paymethod"
                label="Paymethod"
                small
                outlined
                readonly
                hide-details
                class="col-2"
              ></v-text-field>
              <v-text-field
                :value="item.paysystem"
                label="Paysystem"
                small
                outlined
                readonly
                hide-details
                class="col-2"
              ></v-text-field>
              <v-text-field
                :value="item.email"
                label="Email"
                small
                outlined
                readonly
                hide-details
                class="col-2"
              ></v-text-field>
              <v-text-field
                :value="item.phone"
                label="Phone"
                small
                outlined
                readonly
                hide-details
                class="col-2"
              ></v-text-field>
              <v-text-field
                :value="item.created"
                label="Created"
                small
                outlined
                readonly
                hide-details
                class="col-2"
              ></v-text-field>
              <v-text-field
                :value="item.updated"
                label="Updated"
                small
                outlined
                readonly
                hide-details
                class="col-2"
              ></v-text-field>
              <v-text-field
                :value="item.name"
                label="Name"
                small
                outlined
                readonly
                hide-details
                class="col-2"
              ></v-text-field>
              <v-text-field
                :value="item.surname"
                label="Surname"
                small
                outlined
                readonly
                hide-details
                class="col-2"
              ></v-text-field>
            </v-row>

            <v-row class="col-12 px-5 pt-0 payment-handler-details">

              <v-text-field
                v-for="(param, key) in (item.details.params || {})"
                :key="key"
                :value="param"
                :label="startCase(key)"
                small
                outlined
                readonly
                hide-details
                class="col-2"
              ></v-text-field>


              <v-btn
                color="primary"
                class="col-2 my-auto"
                @click="openImage(item)"
                :disabled="!!loadingBill[item.account_transaction_id]"
                :loading="!!loadingBill[item.account_transaction_id]"
              >
                View Bill
                <v-icon small>mdi-clipboard-list-outline</v-icon>
              </v-btn>
              <v-textarea
                v-model="item.comment"
                label="Comment"
                small
                outlined
                auto-grow
                rows="1"
                :readonly="!$store.state.auth.checkAccess({key: 'payment_handler_update', value: true})"
                :append-icon="$store.state.auth.checkAccess({key: 'payment_handler_update', value: true}) ? 'mdi-content-save' : ''"
                @click:append="updateTransaction(item)"
                hide-details
                class="col-12 no-resize"
              ></v-textarea>
            </v-row>

          </td>
        </template>


        <template v-slot:item.login="{ item, header }">
          <a :href="'/user-management/' + item.login " target="_blank">{{ item.login }}</a>
        </template>
        <template v-slot:item.account_id="{ item, header }">
          <a :href="'/user-management/' + item.login " target="_blank">{{ item.account_id }}</a>
        </template>

        <template v-slot:item.bill="{ item, header }">
          <v-btn
            @click="openImage(item)"
            icon
            :disabled="!!loadingBill[item.account_transaction_id]"
            :loading="!!loadingBill[item.account_transaction_id]"
          >
            <v-icon>mdi-clipboard-list-outline</v-icon>
          </v-btn>
        </template>


        <template v-slot:item.status="{ item }">
          <v-select
            :items="statuses"
            v-model="item.status"
            :readonly="!$store.state.auth.checkAccess({key: 'payment_handler_update', value: true})"
            dense
            hide-details
            small
            style="max-width: 150px;"
          ></v-select>
        </template>
        <template v-slot:item.comment="{ item }">
          <div style="min-width: 250px;">
            <v-textarea
              v-model="item.comment"
              small
              auto-grow
              rows="1"
              hide-details
              :readonly="!$store.state.auth.checkAccess({key: 'payment_handler_update', value: true})"
              :append-icon="$store.state.auth.checkAccess({key: 'payment_handler_update', value: true}) ? 'mdi-content-save' : ''"
              @click:append="updateTransaction(item)"
              class="col-12 payment-handler-update-comment pa-0 ma-0"
            ></v-textarea>
          </div>
        </template>
        <template v-slot:item.created="{ item }">
          <div style="min-width: 150px;">
            {{ item.created }}
          </div>
        </template>
        <template v-slot:item.updated="{ item }">
          <div style="min-width: 150px;">
            {{ item.updated }}
          </div>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<style lang="scss" scoped>
  @import './payment-table.scss';
</style>

<script>

  import { get, set, find, map, startCase, cloneDeep, reduce } from 'lodash'
  import { API } from '@/utils/api'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'

  export default {
    components: { SelectProject },

    props: [ 'title' ],
    data: () => ({
      expanded: [],
      entities: false,
      headers: [
        { text: 'Created', value: 'created', 'class': 'nowrap' },
        { text: 'LastUpdate', value: 'updated', 'class': 'nowrap' },
        { text: 'Login', value: 'login', sortable: false, 'class': 'nowrap' },
        { text: 'AccountID', value: 'account_id', sortable: false, 'class': 'nowrap' },
        { text: 'Amount', value: 'amount', 'class': 'nowrap' },
        { text: 'Currency', value: 'currency', 'class': 'nowrap' },
        { text: 'Status', value: 'status', 'class': 'nowrap' },
        { text: 'Reference', value: 'account', 'class': 'nowrap' },
        { text: 'Bill', value: 'bill', 'class': 'nowrap' },
        { text: 'Description', align: 'left', sortable: false, value: 'comment', 'class': 'nowrap' },
        { text: '', value: 'data-table-expand', 'class': 'nowrap' },
      ],
      filters: {
        status: { data: [], type: 'select' },
        account: { data: [], type: 'text' },
        account_id: { data: [], type: 'text' },
        login: { data: [], type: 'text' },
      },
      statuses: [ 'pending', 'complete', 'cancel', 'decline', 'error', 'processing', ],
      project: null,
      loading: false,
      items: [],
      itemsInit: [],
      options: {},
      loadingBill: {},
      total: 0,
    }),

    mounted () {
      this.loadEntities()
    },

    watch: {
      project () {
        if (this.options.page != 1) {
          this.options.page = 1
        } else {
          this.search()
        }
      },
      options: {
        handler () {
          this.search()
        },
      }
    },

    methods: {

      startCase: (k) => startCase(k),

      openImage (item) {
        this.loadingBill[item.account_transaction_id] = true
        API.call('/$v/payment_handler/offline_deposit_bill.json', {
          transaction_id: item.account_transaction_id
        }, null, this.project || this.project.value).then(resp => resp.data).then(r => {

          if (r.img.match(/^data/)) {

            if (window.URL) {

              function base64ToArrayBuffer (_base64Str) {
                let binaryString = window.atob(_base64Str)
                let binaryLen = binaryString.length
                let bytes = new Uint8Array(binaryLen)
                for (let i = 0; i < binaryLen; i++) {
                  let ascii = binaryString.charCodeAt(i)
                  bytes[i] = ascii
                }
                return bytes
              }

              let data = r.img.match(/data:(.*)?;base64,(.*)?/)

              let byte = base64ToArrayBuffer(data[2])

              let blob = new Blob([ byte ], { type: data[1] })

              window.open(window.URL.createObjectURL(blob), '_blank')

            } else {

              let w = window.open('')
              if (r.img.match(/^data:application\/pdf/)) {
                w.document.write('<html><body style="margin:0!important"><embed width="100%" height="100%" src="' + r.img + '" /></body></html>')
              } else {
                w.document.write('<html><body style="margin:0!important"><embed style="max-width: 100%; max-height: 100%;" src="' + r.img + '" /></body></html>')
              }
              w.stop()
            }

          } else {
            window.open(r.img, '_blank')
          }
        }).finally(() => {
          this.loadingBill[item.account_transaction_id] = false
        })
      },

      loadEntities () {
        return API.call('/users/entity_list.json').then(resp => {
          this.entities = resp.data
          return resp.data
        }).catch(e => {
        })
      },

      updateTransaction: async function (item) {

        if (!this.$store.state.auth.checkAccess({ key: 'payment_handler_update', value: true })) {
          return
        }

        let buttons = [
          { text: 'Confirm', value: true, class: 'primary darken-1' },
          { text: 'Cancel', value: false, class: 'grey' },
        ]

        if (get(item, 'status') != get(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'status') && get(item, 'status') === 'complete') {
          buttons = [
            { text: 'Change only status', value: true, class: 'primary darken-1' },
            { text: 'Complete deposit', value: 'increase_balance', class: 'primary darken-1' },
            { text: 'Cancel', value: false, class: 'grey' },
          ]
        }

        let confirmRes = await this.$root.$confirm('Confirm', 'Do you want save changes?', { width: 515, buttons })

        if (confirmRes) {

          API.call('/$v/payment_handler/update.json', {
            account_transaction_id: item.account_transaction_id,
            status: get(item, 'status') != get(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'status') ? item.status : undefined,
            amount: get(item, 'amount') != get(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'amount') ? item.amount : undefined,
            account: get(item, 'account') != get(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'account') ? item.account : undefined,
            comment: item.comment,
            increase_balance: confirmRes == 'increase_balance'
          }, null, this.project || this.project.value).then(resp => {

            if (resp.data.status == item.status || resp.data.comment == item.comment) {
              if (resp.data.comment == item.comment) {
                set(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'comment', item.comment)
              }
              if (resp.data.status == item.status) {
                set(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'status', item.status)
              }
            } else {

              this.$nextTick(function () {
                if (resp.data['comment']) {
                  set(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'comment', resp.data['comment'])
                  item.comment = resp.data.comment
                }
                if (resp.data['status']) {
                  set(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'status', resp.data['status'])
                  item.status = resp.data.status
                }
              })

            }

            this.$notification.show = true
            this.$notification.message = 'Transaction updated'
            this.$notification.type = 'success'

            return resp.data
          }).catch(e => {

            this.search()
          })
        } else {
          this.$nextTick(function () {
            item.comment = get(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'comment')
            item.external_account_transaction_id = get(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'external_transaction_id')
          })
        }
      },

      search: function () {
        this.loading = true

        API.call('/$v/payment_handler/list.json', {
          from: this.from,
          to: this.to,
          type: 'deposit',
          options: this.options,
          filters: {
            paysystem: [ 'offline_deposit' ]
          },
          limit: 50
        }, null, this.project).then(resp => {

          this.total = resp.total
          this.loadingBill = reduce(resp.data, (r, v) => {
            r[v.account_transaction_id] = false
            return r
          }, {})
          this.items = cloneDeep(resp.data)
          this.itemsInit = cloneDeep(resp.data)

          return resp.data
        }).catch(e => {
        }).finally(() => {
          this.loading = false
        })

      },

      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      columnValueList (val) {
        if (val == 'status') {
          return this.statuses
        }
        return this.items.map(d => d[val])
      }
    },
  }
</script>
